import React from 'react';
import PriceDetailsRoot from '../../ExchangeRefundPriceDetails';
const PriceDetailsShortVariant = props => {
    return React.createElement(PriceDetailsRoot, Object.assign({}, props, { variant: "short-details" }));
};
export default PriceDetailsShortVariant;
